import { FormEvent } from 'react'
import { useForm, Link } from '@inertiajs/react'
import AuthLayout from '@/components/layouts/AuthLayout'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import MuiLink from '@mui/material/Link'

export default function Login() {
  const { data, setData, post, processing, errors } = useForm({
    user: {
      email: '',
      password: '',
      remember_me: false as boolean,
    },
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post('/users/sign_in')
  }

  return (
    <AuthLayout title="Sign In">
      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
        <TextField
          label="Email"
          type="email"
          fullWidth
          margin="normal"
          value={data.user.email}
          onChange={(e) => setData('user', { ...data.user, email: e.target.value })}
          error={!!errors['user.email']}
          helperText={errors['user.email']}
          autoFocus
        />
        <TextField
          label="Password"
          type="password"
          fullWidth
          margin="normal"
          value={data.user.password}
          onChange={(e) => setData('user', { ...data.user, password: e.target.value })}
          error={!!errors['user.password']}
          helperText={errors['user.password']}
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          size="large"
          disabled={processing}
          sx={{ mt: 2, mb: 2 }}
        >
          Sign In
        </Button>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <MuiLink component={Link} href="/users/sign_up" underline="hover">
            Create an account
          </MuiLink>
          <MuiLink component={Link} href="/users/password/new" underline="hover">
            Forgot password?
          </MuiLink>
        </Box>
      </Box>
    </AuthLayout>
  )
}
